module.exports = __webpack_public_path__ + "img/yoyo.be5030ca.webp";